import { CardHeader, ToneCard } from "./cardTone";

// قسم داخل نموذج الموظف: كارت مُلوّن ناعم + أيقونة + عنوان + شبكة الحقول.
export const EmployeeFormSection = ({ icon, tone = "primary", title, hint, cols = 2, children, testId }) => {
  const grid =
    cols === 3
      ? "sm:grid-cols-2 lg:grid-cols-3"
      : cols === 2
      ? "sm:grid-cols-2"
      : "";
  return (
    <ToneCard tone={tone} className="animate-rise-in" testId={testId}>
      <CardHeader icon={icon} tone={tone} title={title} hint={hint} />
      <div className={`mt-5 grid gap-4 ${grid}`}>{children}</div>
    </ToneCard>
  );
};

// عنوان قسم صغير داخل الكارت — لتفصيل الحقول (هوية / تعويضات / صلاحيات).
export const SubHeading = ({ title, span = 2, testId }) => (
  <div
    className={`col-span-full sm:col-span-2 lg:col-span-${span} mt-2 flex items-center gap-2`}
    data-testid={testId}
  >
    <span className="h-[2px] w-6 rounded-full bg-current opacity-40" />
    <p className="text-[11px] font-bold uppercase tracking-widest text-muted-foreground">{title}</p>
    <span className="h-[2px] flex-1 rounded-full bg-current opacity-15" />
  </div>
);
